import { defineComponent as _defineComponent } from 'vue'
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
import { instantScrollTo } from '~/helpers/ui/windowBehaviors';

export default /*#__PURE__*/_defineComponent({
  __name: 'AzBackToTopButton',
  setup(__props) {


return { __sfc: true,AzIcon, instantScrollTo }
}

})